module.exports = __webpack_public_path__ + "img/page8_blur.3f6f598a.png";